var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174 173",
    style: {
      enableBackground: "new 0 0 174 173"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Scroll Down \u2014 Scroll") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,22.1c0.5,0.7,1.3,0.9,2.2,0.4c1-0.5,1.1-1.1,0.7-1.7c-0.4-0.8-1.1-0.8-2.5-0.5c-2.2,0.5-3.3,0.2-4-1 c-0.9-1.6-0.1-3.1,1.5-4c2-1.1,3.4-0.5,4.3,0.8L50.2,17c-0.4-0.6-1-0.9-1.9-0.4c-0.8,0.4-0.9,1-0.6,1.6c0.3,0.6,0.9,0.6,2.2,0.3 c2.5-0.6,3.5,0,4.2,1.2c0.8,1.4,0.5,3-1.7,4.3c-1.8,1-3.5,0.8-4.6-0.9L49.7,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,14.2c0.3,1.6-0.3,3.4-2.6,4.2c-2.9,1-4.6-0.8-5.5-3.4s-0.2-5.1,2.4-6c2.5-0.8,3.9,0.4,4.5,1.8l-1.8,0.6 c-0.4-0.7-1-1.3-2.2-0.9c-1.5,0.5-1.5,2.2-1,3.8c0.6,1.7,1.5,3.1,3.1,2.5c1.2-0.4,1.3-1.4,1.2-2.1L67.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9,11.4l0.5,3.9l-1.9,0.2L74.3,6l3.9-0.5C80,5.3,81.4,6,81.6,7.7c0.2,1.3-0.4,2-1.2,2.4 c1,0.2,1.4,0.9,1.6,2.1v0.2c0.1,0.8,0.3,1.6,0.4,2.2l-1.9,0.2c-0.2-0.4-0.3-1-0.5-2.2v-0.3c-0.1-1.1-0.6-1.4-1.8-1.3L76.9,11.4z  M76.6,9.9L78,9.7c0.9-0.1,1.6-0.5,1.5-1.5c-0.1-0.9-0.8-1.1-1.6-1l-1.6,0.2L76.6,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.7,10.1c-0.2,2.8-1.6,4.9-4.7,4.7c-3-0.2-4.1-2.5-3.9-5.3c0.1-2.4,1.6-4.8,4.7-4.6 C96.6,5.2,97.8,7.6,97.7,10.1z M91.1,9.7c-0.1,1.9,0.5,3.5,2.1,3.6c1.7,0.1,2.4-1.3,2.5-3.3c0.1-1.8-0.4-3.4-2.1-3.5 C92,6.5,91.2,7.9,91.1,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.4,6.9l1.9,0.5l-2,7.7l4.2,1.1l-0.6,1.5l-5.8-1.5L106.4,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,11.1l1.8,0.8l-3.3,7.3l3.9,1.7l-0.8,1.4l-5.5-2.5L120,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.9,25.6l-2-1.7l1.1-1.2l5.4,4.7l-1.1,1.2l-2-1.7l-5.2,6.1l-1.5-1.3L140.9,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.6,42.5c-2.2,1.7-4.7,2.1-6.6-0.3c-1.9-2.3-0.9-4.7,1.3-6.4c1.8-1.5,4.6-2,6.5,0.4 C155.5,38.5,154.6,40.9,152.6,42.5z M148.5,37.5c-1.5,1.2-2.2,2.7-1.3,3.9c1,1.3,2.5,0.9,4.1-0.4c1.4-1.1,2.2-2.5,1.1-3.9 C151.5,35.9,149.9,36.3,148.5,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.9,46.8l1.6,3.1c0.8,1.6,0.8,3.4-1,4.3c-1.8,0.9-3.4,0.1-4.3-1.7l-0.7-1.2l-3.3,1.7l-0.9-1.7L160.9,46.8z  M158,50.5l0.6,1.1c0.5,0.9,1.1,1.3,2.1,0.8c0.8-0.4,0.9-1.2,0.4-2.1l-0.6-1.2L158,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.5,74.1l-1.6,0.3l-0.7-3.6l1.6-0.3L165.5,74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.1,92c-0.9,0.1-1.5,0.6-1.6,1.6c-0.1,1.1,0.4,1.5,1.1,1.5c0.9,0.1,1.3-0.4,1.7-1.8c0.8-2.2,1.6-2.9,3-2.8 c1.8,0.1,2.6,1.6,2.5,3.4c-0.2,2.3-1.4,3.2-3,3.2l0.1-1.9c0.7-0.1,1.3-0.4,1.3-1.4c0.1-0.9-0.3-1.3-1-1.4c-0.7,0-0.9,0.4-1.4,1.7 c-0.9,2.4-1.9,3-3.3,2.9c-1.6-0.1-2.8-1.2-2.7-3.7c0.1-2.1,1.3-3.4,3.2-3.4L165.1,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,111.5c-1.5-0.7-2.7-2.1-2.1-4.5c0.8-2.9,3.2-3.4,5.8-2.7s4.4,2.6,3.7,5.3c-0.6,2.5-2.5,3.1-4,2.8l0.5-1.8 c0.8,0,1.6-0.1,2-1.4c0.4-1.5-1-2.5-2.7-2.9c-1.8-0.5-3.4-0.4-3.8,1.2c-0.3,1.2,0.4,1.8,1.1,2.2L162,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.5,120.5l-3.6-1.7l0.8-1.7l8.7,4.1l-1.7,3.5c-0.8,1.6-2.1,2.4-3.7,1.7c-1.2-0.6-1.5-1.5-1.4-2.3 c-0.7,0.7-1.6,0.7-2.6,0.2l-0.2-0.1c-0.8-0.4-1.5-0.7-2-0.8l0.8-1.7c0.4,0,1,0.3,2.1,0.8l0.2,0.1c1,0.5,1.5,0.3,2-0.9L159.5,120.5z  M160.9,121.1l-0.6,1.3c-0.4,0.8-0.5,1.6,0.5,2.1c0.8,0.4,1.4-0.1,1.7-0.8l0.7-1.6L160.9,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.2,138.7c-2.2-1.6-3.2-4-1.4-6.5c1.8-2.4,4.3-2,6.5-0.4c1.9,1.4,3.1,3.9,1.3,6.4 C153.9,140.5,151.3,140.2,149.2,138.7z M153.1,133.4c-1.5-1.1-3.2-1.4-4.1-0.2c-1,1.3-0.2,2.7,1.4,3.9c1.4,1.1,3,1.5,4,0.1 C155.4,135.9,154.6,134.5,153.1,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.2,147.8l-1.4,1.3l-5.4-5.9l-3.1,2.9l-0.9-1.3l4.4-4.1L147.2,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.4,156.8l-1.6,1.1l-4.4-6.7l-3.6,2.3l-0.8-1.4l5-3.3L136.4,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,166.6l2.5-0.7l0.5,1.5l-6.9,2l-0.5-1.5l2.5-0.7l-2.3-7.6l1.9-0.6L112.8,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.2,167.1c-0.3-2.7,0.8-5.1,3.8-5.4c2.9-0.3,4.4,1.8,4.7,4.6c0.2,2.4-0.8,5-3.8,5.3 C94,171.9,92.5,169.7,92.2,167.1z M98.7,166.5c-0.2-1.9-1.1-3.3-2.6-3.2c-1.7,0.2-2.1,1.6-1.9,3.6c0.2,1.8,0.9,3.2,2.6,3.1 C98.4,169.8,98.9,168.3,98.7,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.1,171.8l-3.5-0.3c-1.8-0.2-3.3-1.2-3.1-3.2c0.2-2,1.7-2.9,3.8-2.7l1.4,0.1l0.3-3.6l2,0.2L84.1,171.8z  M82.5,167.3l-1.3-0.1c-1-0.1-1.7,0.2-1.8,1.3c-0.1,1,0.5,1.4,1.5,1.5l1.3,0.1L82.5,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.6,160.9l0.6-1.5l3.4,1.3l-0.6,1.5L58.6,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,150.9c0.4-0.8,0.3-1.6-0.5-2.2c-0.9-0.7-1.5-0.5-1.9,0c-0.5,0.7-0.3,1.3,0.6,2.4c1.4,1.8,1.5,2.9,0.7,4 c-1.1,1.4-2.8,1.4-4.2,0.3c-1.8-1.4-1.9-2.9-1.1-4.2l1.5,1.1c-0.3,0.6-0.4,1.3,0.4,1.9c0.7,0.5,1.3,0.4,1.7-0.1 c0.4-0.6,0.2-1-0.7-2.2c-1.5-2-1.5-3.2-0.6-4.3c0.9-1.3,2.6-1.7,4.6-0.2c1.7,1.3,2.1,2.9,1.1,4.5L43.8,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,137.6c1.4-0.9,3.2-1.2,4.9,0.7c2,2.2,1.2,4.5-0.8,6.4c-2,1.8-4.6,2.3-6.5,0.3c-1.8-1.9-1.2-3.8-0.2-4.8 l1.3,1.4c-0.4,0.7-0.8,1.4,0.1,2.4c1.1,1.2,2.6,0.5,3.9-0.7s2.2-2.7,1-3.9c-0.9-0.9-1.8-0.6-2.4-0.3L29,137.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,130.7l3.4-2.1l1,1.6l-8.1,5.1l-2.1-3.3c-1-1.5-0.9-3.1,0.6-4c1.1-0.7,2-0.4,2.7,0.1 c-0.2-1,0.3-1.7,1.3-2.3l0.2-0.1c0.7-0.4,1.4-0.9,1.8-1.3l1,1.6c-0.3,0.3-0.8,0.7-1.8,1.3l-0.2,0.1c-0.9,0.6-1,1.1-0.4,2.2 L22.9,130.7z M21.6,131.5l-0.8-1.2c-0.5-0.8-1.1-1.3-2-0.7c-0.8,0.5-0.7,1.2-0.3,1.9l0.9,1.5L21.6,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,112.2c2.6-1,5.1-0.5,6.2,2.3c1,2.8-0.6,4.8-3.2,5.7c-2.2,0.8-5,0.5-6.1-2.4 C9,115.2,10.7,113.1,13.1,112.2z M15.4,118.4c1.8-0.7,2.9-1.9,2.4-3.3c-0.6-1.6-2.1-1.6-4-0.9c-1.7,0.6-2.9,1.7-2.3,3.3 C12.1,118.9,13.7,119,15.4,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,105.6l-0.3-1.9l7.9-1.4l-0.7-4.2L15,98l1.1,5.9L6.5,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,80.2l-0.3,2.6l-1.6-0.2l0.8-7.1l1.6,0.2L7,78.2l7.9,0.9l-0.2,2L6.8,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,61c2.6,0.8,4.4,2.7,3.5,5.6c-0.9,2.8-3.4,3.4-6,2.6c-2.3-0.7-4.3-2.7-3.4-5.6 C9.2,60.9,11.8,60.3,14.3,61z M12.4,67.3c1.8,0.6,3.5,0.3,4-1.2c0.5-1.6-0.7-2.6-2.6-3.2c-1.7-0.5-3.4-0.4-3.9,1.2 C9.4,65.7,10.6,66.8,12.4,67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.2,51.7l1.7-3.1c0.9-1.6,2.4-2.5,4.1-1.6c1.8,0.9,2,2.7,1,4.6l-0.7,1.2l3.3,1.8l-1,1.7L13.2,51.7z M18,52.1 l0.6-1.1c0.5-0.9,0.5-1.7-0.5-2.2c-0.8-0.5-1.5-0.1-2,0.8l-0.6,1.2L18,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,32.7l1.1,1.1l-2.5,2.6l-1.1-1.1L33.3,32.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollTop);
export default __webpack_public_path__ + "static/media/scroll_top.315423c110abc42670f492f118f6f970.svg";
export { ForwardRef as ReactComponent };